import PropTypes from "prop-types";

export const EmojiConfirmPopupPropTypes = {
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    setOpen: PropTypes.func,
    loading: PropTypes.bool,
    closable: PropTypes.bool,
};
